import { useEffect } from 'react';
import { ADReactFlowGraph } from '../components/ad/ADReactFlowGraph';
import { QueryToolbar } from '../components/ad/QueryToolbar';
import { ADInspector } from '../components/ad/ADInspector';
import { useADStore } from '../store/adStore';
import { fetchTenants } from '../services/adApi';
import { toast } from 'sonner';
import { ReactFlowProvider } from '@xyflow/react';

const Index = () => {
  const { setTenants, setSelectedTenant } = useADStore();


  // Fetch tenants on mount and auto-select first
  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchTenants();
        const formatted = data.map(t => ({ tenantName: t.tenantName }));
        setTenants(formatted);
        if (formatted.length > 0) {
          setSelectedTenant(formatted[0].tenantName);
        }
      } catch (err) {
        console.error('Failed to load tenants:', err);
        toast.error('Failed to load tenants');
      }
    };
    load();
  }, [setTenants, setSelectedTenant]);

  return (
    <ReactFlowProvider>
      <div className="ad-analytics-page relative flex flex-col h-screen w-full overflow-hidden bg-background">
        {/* Grid Background — Light theme */}
        <div
          className="absolute inset-0 z-0 pointer-events-none dark:hidden"
          style={{
            backgroundImage: [
              `linear-gradient(to right, rgba(200, 200, 200, 0.15) 1px, transparent 1px)`,
              `linear-gradient(to bottom, rgba(200, 200, 200, 0.15) 1px, transparent 1px)`,
              `radial-gradient(circle at 0 0, rgba(160, 160, 160, 0.35) 2.5px, transparent 2.5px)`,
            ].join(', '),
            backgroundSize: '40px 40px, 40px 40px, 40px 40px',
          }}
        />
        {/* Grid Background — Dark theme */}
        <div
          className="absolute inset-0 z-0 pointer-events-none hidden dark:block"
          style={{
            backgroundImage: [
              `linear-gradient(to right, rgba(255, 255, 255, 0.025) 1px, transparent 1px)`,
              `linear-gradient(to bottom, rgba(255, 255, 255, 0.025) 1px, transparent 1px)`,
              `radial-gradient(circle at 0 0, rgba(255, 255, 255, 0.05) 2.5px, transparent 2.5px)`,
            ].join(', '),
            backgroundSize: '40px 40px, 40px 40px, 40px 40px',
          }}
        />

        {/* Query title was removed here and moved to QueryToolbar */}

        {/* Graph */}
        <div className="flex-1 relative z-10">
          <ADReactFlowGraph />
        </div>

        {/* Inspector */}
        <ADInspector />

        {/* Bottom Query Toolbar */}
        <QueryToolbar />
      </div>
    </ReactFlowProvider>
  );
};

export default Index;
